import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from './components/avatar/avatar.component';
import { UsersService } from '../users/users.service';
import { WebCamModule } from '../A2-utils/web-cam/web-cam.module';

@NgModule({
  imports: [
    CommonModule,
    WebCamModule
  ],
  declarations: [AvatarComponent],
  exports: [AvatarComponent],
  providers: [
    UsersService
  ]
})
export class ProfilesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/profiles/profiles.module.ts